import { FinancialDetailEntity } from 'core/models';
import { inject, injectable } from 'inversify';
import { HttpClientService } from './http-client.service';

const API_BASE = '/api';

@injectable()
export class FinancialsService {
  @inject(HttpClientService)
  private httpClient: HttpClientService;

  public getFinancialDetail(symbol: string): Promise<FinancialDetailEntity> {
    return this.httpClient.get(API_BASE + '/v1/financials/' + symbol);
  }
}
